import * as hooks from './hooks';

export const WrapperConditions = () => {
    hooks.useTriggerOnWrapperInit();

    return null;
};
